export default {
  data() {
    return {
      callbacks: ''
    };
  },
  watch: {},
  methods: {
    beforeOpen(ev) {
      this.modal = this.$refs.modal;
      let empty = (data) => {
        console.log('empty -> data', data);
      };
      let { onClickUpload = empty, onFile = empty, onUrl = empty, onInfo = empty, onConfirm = empty, onCancel = empty, onClose = empty } =
        ev.params || {};
      this.callbacks = {
        onClickUpload,
        onFile,
        onUrl,
        onInfo,
        onConfirm,
        onCancel,
        onClose
      };
    }
  }
};
